function GetPanels() {
  const panelSquares = window.panels
  const newPanels = window.sortByProp(
    panelSquares.filter((x) => x.new),
    'title'
  )
  const others = window.uniqueByProp(panelSquares, newPanels, 'title')
  return [...newPanels, ...window.sortByProp(others, 'title')]
}

function getProjects() {
  return window.projects
}

function LoadCurrentFromUrl() {
  const url = new URL(window.location.href)
  const urlPanel = url.searchParams.get('panel')
  const allPanels = GetPanels()
  if (!urlPanel) return allPanels[0]
  return allPanels.find((x) => x.key === urlPanel) ?? allPanels[0]
}
